import { sendEditSuggestion } from '../../services/api';
import {
  InnerApiCallError,
  ExternalApiCallError,
  ClientError,
} from '../../contexts/app-error-context';

import { sendReportToSentry } from './sentry';
import { storeLastSubmittedEmail } from './emailCache';

/**
 *
 * @param {object} options
 * @param {string} options.editSuggestionType
 * @param {string} options.origin
 * @param {object} payload
 * @returns {object}
 * @throws {InnerApiCallError} Will throw an error if sendEditSuggestion request fails
 */
export const sendEditSuggestionAction = async (
  { editSuggestionType, origin },
  payload,
) => {
  try {
    return await sendEditSuggestion(editSuggestionType, payload);
  } catch (err) {
    sendReportToSentry(err, { origin });
    throw new InnerApiCallError();
  }
};

/**
 *
 * @param {object} options
 * @param {string} options.email
 * @param {string} options.origin
 * @param {object} editSuggestionResult
 * @throws {ClientError} Will throw an error if attempt to store email to local storage fails
 */
export const storeLastSubmittedEmailAction = (
  { email, origin },
  editSuggestionResult,
) => {
  try {
    if (editSuggestionResult && editSuggestionResult.status === 'ok') {
      storeLastSubmittedEmail(email);
    }
  } catch (err) {
    sendReportToSentry(err, { origin });
    throw new ClientError();
  }
};

/**
 *
 * @param {object} options
 * @param {string} options.analyticsTrackingMessage
 * @param {string} options.origin
 * @throws {ExternalApiCallError} Will throw an error if external analytics request fails
 */
export const analyticsTrackAction = ({
  analyticsTrackingMessage,
  origin,
  analyticsTrackParams,
}) => {
  try {
    analytics.track(analyticsTrackingMessage, analyticsTrackParams);
  } catch (err) {
    sendReportToSentry(err, { origin });
    throw new ExternalApiCallError();
  }
};
